export default function scrollTo(ref: HTMLElement, offset: number) {
    if (ref) {
        ref.scrollTo(0, offset);
    }
}
